//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuSub from "./menu-sub.vue";
import MenuItem from "./menu-item.vue";
import mobileMenu from "./mobile-menu.vue";

import menuDatas from "./menu.json";
// 2025.06.13 新改动，采用新的菜单结构
import menuDatasNew from "./menu-new.json";
import menuBlog from "./menu-blog.vue";
import { BUS } from "../../../../tools/tools";
import { filterDownloadMenu } from "../../../../tools/tools";

export default {
  name: "",
  components: {
    MenuSub,
    MenuItem,
    mobileMenu,
    menuBlog,
  },
  props: {
    theme: {
      type: String,
      default: "",
    },
    isTikTokChannel: {
      type: Boolean,
      default: false,
    },
    greyToggle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSub: "-1",
      menuDatas: menuDatas,
      menuDatasNew: menuDatasNew,
    };
  },
  methods: {
    openSub(id) {
      this.showSub = id;
    },
    closeSub() {
      if (this.showSub) {
        this.showSub = "";
      }
    },
    closeMenu() {
      this.$emit("closeMenu");
    },
  },
  computed: {
    datas() {
      // 如果灰度开关是true，那么使用新的json，否则使用旧的json
      if (this.greyToggle) {
        this.menuDatas = this.menuDatasNew;
      }
      const menuConfig = this.isTikTokChannel
        ? filterDownloadMenu(this.menuDatas)
        : this.menuDatas;
      return menuConfig;
    },
  },
  mounted() {
    BUS.on("setUserInfo", async (userdatas) => {
      this.user = userdatas;
      if (!userdatas) return;
    });
    document.addEventListener("click", this.closeSub);
  },
};
